module.exports = __webpack_public_path__ + "img/check-list.67fc4a70.svg";